// src/pages/healthcare/appointments/components/calendarLocalizer.ts
import { dayjsLocalizer } from "react-big-calendar";
import { dayjs } from "../../../../utils/time";

// RBC self-extends the eight plugins it needs but not timezone, which the shared singleton carries.
export const calendarLocalizer = dayjsLocalizer(dayjs);

// ⚠️ A timezone-extended dayjs routes RBC through `dayjs.tz`, which cannot read the "MM/DD/YYYY HH:mm:ss" its merge() reparses — it returned midnight, collapsing min/max/scrollToTime and every slot time to 00:00.
calendarLocalizer.merge = (date: Date, time: Date): Date | null => {
	if (!date && !time) return null;
	const day = date ?? time;
	const clock = time ?? date;
	return new Date(day.getFullYear(), day.getMonth(), day.getDate(), clock.getHours(), clock.getMinutes(), clock.getSeconds(), 0);
};

const MONDAY = 1;

const mondayOf = (date: Date): Date => {
	const start = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	start.setDate(start.getDate() - ((start.getDay() + 7 - MONDAY) % 7));
	return start;
};

const isWeek = (unit: unknown): boolean => String(unit).toLowerCase() === "week";

const baseStartOf = calendarLocalizer.startOf;
const baseEndOf = calendarLocalizer.endOf;

// RBC ignores its own firstOfWeek() and takes the boundary from dayjs's locale weekStart, which is shared with every antd picker in the app — so Monday is pinned on this localizer instead of on the locale.
calendarLocalizer.startOfWeek = () => MONDAY;

calendarLocalizer.startOf = (date, unit) => (isWeek(unit) ? mondayOf(date) : baseStartOf(date, unit));

calendarLocalizer.endOf = (date, unit) => {
	if (!isWeek(unit)) return baseEndOf(date, unit);
	const end = mondayOf(date);
	end.setDate(end.getDate() + 6);
	end.setHours(23, 59, 59, 999);
	return end;
};
